import { Button } from "@chakra-ui/react";

export function ActionButton() {
  return (
    <Button
      type="button"
      color={"#FFFFFF"}
      backgroundColor={"#6200FF"}
      borderRadius={"8px"}
      size="sm"
      border="1px solid #6200FF"
      _hover={{
        bg: "#6200FF",
        borderColor: "#6200FF",
        color: "#FFFFFF",
      }}
      variant="outline"
    >
      Action
    </Button>
  );
}
